<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useBranding } from 'shared/composables/useBranding';

import PageHeader from '../SettingsSubPageHeader.vue';

const { t } = useI18n();
const route = useRoute();
const { replaceInstallationName } = useBranding();

const globalConfig = useMapGetter('globalConfig/get');

const createFlowSteps = computed(() => {
  const steps = ['CHANNEL', 'INBOX', 'AGENT', 'FINISH'];

  const routes = {
    CHANNEL: 'settings_inbox_new',
    INBOX: 'settings_inboxes_page_channel',
    AGENT: 'settings_inboxes_add_agents',
    FINISH: 'settings_inbox_finish',
  };

  return steps.map(step => {
    return {
      title: t(`INBOX_MGMT.CREATE_FLOW.${step}.TITLE`),
      body: t(`INBOX_MGMT.CREATE_FLOW.${step}.BODY`),
      route: routes[step],
    };
  });
});

const isFirstStep = computed(() => {
  return route.name === 'settings_inbox_new';
});

const isFinishStep = computed(() => {
  return route.name === 'settings_inbox_finish';
});

const pageTitle = computed(() => {
  if (isFirstStep.value) {
    return t('INBOX_MGMT.ADD.AUTH.TITLE');
  }
  if (isFinishStep.value) {
    return t('INBOX_MGMT.ADD.AUTH.TITLE_FINISH');
  }
  return t('INBOX_MGMT.ADD.AUTH.TITLE_NEXT');
});

const items = computed(() => {
  return createFlowSteps.value.map(item => ({
    ...item,
    body: replaceInstallationName(item.body),
  }));
});
</script>

<!-- Phase 9.6: the new-inbox steps on the kit's plant — the steps in a narrow column beside the step's form, in
     one card; on a phone the steps fold away and the page title says where you are. Step 1 is "All channels". -->
<template>
  <div class="mx-auto w-full max-w-[100rem] px-6 py-6">
    <PageHeader class="lg:hidden" :header-title="pageTitle" />
    <div
      class="grid min-h-[50dvh] grid-cols-1 overflow-hidden rounded-polaris-xl border border-solid border-polaris-border bg-polaris-card lg:grid-cols-[18rem_1fr]"
    >
      <aside
        class="hidden border-0 border-e border-solid border-polaris-border p-6 lg:block"
      >
        <woot-wizard :global-config="globalConfig" :items="items" />
      </aside>
      <div class="flex min-w-0 flex-col overflow-y-auto">
        <router-view />
      </div>
    </div>
  </div>
</template>
